import React from "react";
import type { IconProps } from "./types";

export const CpuIcon = React.forwardRef<SVGSVGElement, IconProps>(
  function CpuIcon({ size = 24, width, height, className = "", fill = "currentColor", ...props }, ref) {
    return (
      <svg
        ref={ref}
        width={width || size}
        height={height || size}
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <g>
          <path
            d="M167.314,14.993C167.314,6.712,160.603,0,152.332,0h-5.514c-8.27,0-14.982,6.712-14.982,14.993v41.466h35.478
            V14.993z"
            fill={fill}
          />
          <path
            d="M238.261,14.993C238.261,6.712,231.549,0,223.279,0h-5.503c-8.271,0-14.982,6.712-14.982,14.993v41.466h35.468
            V14.993z"
            fill={fill}
          />
          <path
            d="M309.207,14.993C309.207,6.712,302.496,0,294.225,0h-5.504c-8.27,0-14.982,6.712-14.982,14.993v41.466h35.468
            V14.993z"
            fill={fill}
          />
          <path
            d="M380.164,14.993C380.164,6.712,373.453,0,365.182,0h-5.514c-8.271,0-14.982,6.712-14.982,14.993v41.466h35.478
            V14.993z"
            fill={fill}
          />
          <path
            d="M131.836,497.007c0,8.282,6.711,14.993,14.982,14.993h5.514c8.271,0,14.982-6.711,14.982-14.993V455.55
            h-35.478V497.007z"
            fill={fill}
          />
          <path
            d="M202.793,497.007c0,8.282,6.712,14.993,14.982,14.993h5.503c8.27,0,14.982-6.711,14.982-14.993V455.55h-35.468
            V497.007z"
            fill={fill}
          />
          <path
            d="M273.739,497.007c0,8.282,6.712,14.993,14.982,14.993h5.504c8.272,0,14.982-6.711,14.982-14.993V455.55
            h-35.468V497.007z"
            fill={fill}
          />
          <path
            d="M344.686,497.007c0,8.282,6.712,14.993,14.982,14.993h5.514c8.27,0,14.982-6.711,14.982-14.993V455.55h-35.478
            V497.007z"
            fill={fill}
          />
          <path
            d="M497.018,131.836h-41.466v35.479h41.466c8.272,0,14.982-6.712,14.982-14.993v-5.493
            C512,138.548,505.289,131.836,497.018,131.836z"
            fill={fill}
          />
          <path
            d="M497.018,202.793h-41.466v35.468h41.466c8.272,0,14.982-6.712,14.982-14.982v-5.494
            C512,209.504,505.289,202.793,497.018,202.793z"
            fill={fill}
          />
          <path
            d="M497.018,273.739h-41.466v35.468h41.466c8.272,0,14.982-6.711,14.982-14.992v-5.494
            C512,280.451,505.289,273.739,497.018,273.739z"
            fill={fill}
          />
          <path
            d="M497.018,344.686h-41.466v35.479h41.466c8.272,0,14.982-6.712,14.982-14.993v-5.493
            C512,351.398,505.289,344.686,497.018,344.686z"
            fill={fill}
          />
          <path
            d="M0,146.828v5.493c0,8.281,6.712,14.993,14.982,14.993H56.46v-35.479H14.982C6.712,131.836,0,138.548,0,146.828
            z"
            fill={fill}
          />
          <path
            d="M0,217.785v5.494c0,8.27,6.712,14.982,14.982,14.982H56.46v-35.468H14.982C6.712,202.793,0,209.504,0,217.785z
            "
            fill={fill}
          />
          <path
            d="M0,288.721v5.494c0,8.281,6.712,14.992,14.982,14.992H56.46v-35.468H14.982C6.712,273.739,0,280.451,0,288.721
            z"
            fill={fill}
          />
          <path
            d="M0,359.679v5.493c0,8.281,6.712,14.993,14.982,14.993H56.46v-35.479H14.982C6.712,344.686,0,351.398,0,359.679
            z"
            fill={fill}
          />
          <path
            d="M78.628,433.382h354.754V78.628H78.628V433.382z M139.586,139.58h232.839V372.42H139.586V139.58z"
            fill={fill}
          />
          <rect x="184.362" y="184.362" width="143.288" height="143.287" fill={fill} />
        </g>
      </svg>
    );
  }
);
